import React, { useState } from 'react';
import axios from 'axios';
import { useT } from '../i18n';
import { useLang } from '../context/LangContext';

export default function ForgotPassword() {
  const t = useT();
  const { lang, setLang } = useLang();
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(false);
  const [error, setError]     = useState(null);

  const inputStyle = {
    width: '100%',
    boxSizing: 'border-box',
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid rgba(59,73,75,0.6)',
    color: '#e2e2e8',
    fontFamily: "var(--font-display)",
    fontSize: 15,
    padding: '8px 0',
    outline: 'none',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await axios.post('/api/auth/forgot-password', { email, lang });
      setDone(true);
    } catch (_) {
      setDone(true); // always show success to not reveal email existence
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--surface-base)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
    }}>
      {/* Lang toggle */}
      <div style={{ position: 'fixed', top: 20, right: 20, display: 'flex', gap: 6 }}>
        {['de', 'en'].map(l => (
          <button key={l} onClick={() => setLang(l)} style={{
            background: 'transparent',
            border: `1px solid ${lang === l ? 'rgba(var(--brand-primary-rgb),0.6)' : 'rgba(59,73,75,0.35)'}`,
            color: lang === l ? 'var(--brand-primary)' : '#849495',
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 9,
            fontWeight: 700,
            letterSpacing: '0.12em',
            padding: '5px 10px',
            cursor: 'pointer',
          }}>{l.toUpperCase()}</button>
        ))}
      </div>

      <div style={{
        width: '100%',
        maxWidth: 420,
        background: 'rgba(17,19,24,0.95)',
        border: '1px solid rgba(59,73,75,0.35)',
        padding: '40px 36px',
      }}>
        <div style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: '0.2em',
          color: 'var(--brand-primary)',
          marginBottom: 32,
        }}>
          CRIT ROSTER
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 20 }}>📬</div>
            <h2 style={{ margin: '0 0 12px', fontSize: 20, fontWeight: 800, color: '#e2e2e8' }}>
              {t('forgot_sent_title')}
            </h2>
            <p style={{ margin: '0 0 28px', fontSize: 13, color: 'rgba(185,202,203,0.7)', lineHeight: 1.6 }}>
              {t('forgot_sent_text')}
            </p>
            <a href="/" style={{
              display: 'block',
              width: '100%',
              boxSizing: 'border-box',
              padding: '14px 20px',
              background: 'transparent',
              border: '1px solid rgba(59,73,75,0.5)',
              color: '#849495',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.14em',
              textDecoration: 'none',
              textAlign: 'center',
            }}>
              {t('forgot_back_login')}
            </a>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 800, color: '#e2e2e8' }}>
              {t('forgot_title')}
            </h2>
            <p style={{ margin: '0 0 28px', fontSize: 13, color: 'rgba(185,202,203,0.7)', lineHeight: 1.6 }}>
              {t('forgot_subtitle')}
            </p>

            <div style={{ marginBottom: 28 }}>
              <label style={{ display: 'block', marginBottom: 8, fontFamily: "'JetBrains Mono', monospace", fontSize: 9, fontWeight: 700, letterSpacing: '0.13em', color: '#849495' }}>
                {t('login_email')}
              </label>
              <input
                type="email"
                value={email}
                required
                autoFocus
                onChange={e => setEmail(e.target.value)}
                style={inputStyle}
                onFocus={e => e.target.style.borderBottomColor = 'var(--brand-primary)'}
                onBlur={e  => e.target.style.borderBottomColor = 'rgba(59,73,75,0.6)'}
              />
            </div>

            {error && (
              <div style={{ marginBottom: 16, padding: '10px 14px', background: 'rgba(192,0,43,0.12)', border: '1px solid rgba(192,0,43,0.35)', color: '#ff6b6b', fontFamily: "'JetBrains Mono', monospace", fontSize: 10 }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '16px 20px',
                background: loading ? 'rgba(var(--brand-primary-rgb),0.4)' : 'var(--brand-primary)',
                border: 'none',
                color: '#002022',
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '0.14em',
                cursor: loading ? 'not-allowed' : 'pointer',
                marginBottom: 20,
              }}
            >
              {loading ? t('forgot_sending') : t('forgot_send')}
            </button>

            <div style={{ textAlign: 'center' }}>
              <a href="/" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: '#849495', letterSpacing: '0.1em', textDecoration: 'none' }}>
                {t('forgot_back_login')}
              </a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
